module.exports = __webpack_public_path__ + "img/预警信息2 - 副本.bb27ed83.png";